import { Transaction } from "@bitwarden/web-vault/app/models/data/blobby/transaction.data";
import { DateUtil } from "@bitwarden/web-vault/app/shared/utils/helper.date/date-util";
import { GlossDateAsObjectType } from "@bitwarden/web-vault/app/models/store/types/store.types";
import { format } from "date-fns";

/**
 * @deprecated dateToGlossDate is deprecated and will be removed in the future.
 */
export const dateToGlossDate = (
  date: Date,
  isTimeKnown = false,
  timezone?: string,
): GlossDateAsObjectType => {
  return {
    date: format(date, "yyyy-MM-dd"),
    time: isTimeKnown ? format(date, "HH:mm:ss") : null,
    timeZone: timezone,
    reliableTimeSource: false,
  };
};

/**
 * @deprecated GlossDateOld is deprecated and will be removed in the future. Please use GlossDateAbstraction instead.
 */
export class GlossDateOld {
  static readonly EPOCH_DATE: string = "1970-01-01";

  private _date: Date;
  private _dateString: string;
  private _time: string = undefined;
  private _timeZone: string = undefined;

  /**
   * @deprecated This constructor is deprecated and will be removed in the future.
   */
  static fromModel(obj: GlossDateAsObjectType): GlossDateOld {
    const glossDate = new GlossDateOld();
    glossDate.date = new Date(obj.date);
    glossDate.dateString = glossDate.date.toISOString();
    glossDate.time = obj.time;
    glossDate.timeZone = obj.timeZone;
    return glossDate;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  get date(): Date {
    return this._date;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  set date(value: Date) {
    this._date = value;
  }

  /**
   * todo this need to be double checked in the new mapping.
   * **/
  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  get dateString(): string {
    return this._dateString;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  set dateString(value: string) {
    this._dateString = value;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  get time(): string | undefined {
    return this._time;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  set time(value: string | undefined) {
    this._time = value;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  get timeZone(): string {
    return this._timeZone;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  set timeZone(value: string) {
    this._timeZone = value;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  static getDateAsString(dateType: GlossDateOld): string {
    const { date, time, timeZone } = dateType;

    return `${date}${time ? "T" + time : ""}${timeZone ? "" + timeZone : ""}`;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  static getEpochDateTime() {
    return this.EPOCH_DATE;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  static getNow() {
    return new Date();
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  static extractDate(transaction: Transaction) {
    const glossDate = transaction["_transactionDate"];
    return glossDate.date;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  setToDateObj(transactionDate: GlossDateOld | string): GlossDateOld {
    if (transactionDate instanceof GlossDateOld) {
      this.date = new Date(transactionDate.date);
      return transactionDate;
    }

    let dateString;
    if (typeof transactionDate === "object" && transactionDate) {
      this.timeZone = transactionDate["_timeZone"];
      this.time = transactionDate["_time"];
      if (transactionDate?.["_dateString"]) {
        dateString = transactionDate["_dateString"];
      } else {
        dateString = transactionDate["_date"];
      }
    } else {
      dateString = transactionDate;
    }
    return this.process(dateString);
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   *
   * Process the GlossDate to set the correct value of the properties
   * date: Date object
   * time: string - set to undefined if date provided is 00:00:00Z
   * timeZone: string - set to undefined if date provided is 00:00:00Z
   *
   * @param transactionDate
   */
  private process(transactionDate: string) {
    if (!transactionDate) {
      return;
    }

    this.date = new Date(transactionDate);
    this.dateString = transactionDate;

    if (DateUtil.isTimeSetFromDate(transactionDate)) {
      this.time = this.date.getTime().toString();
    }

    return this;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  getMonthDifference(date: GlossDateOld): number {
    let startYear, startMonth, endYear, endMonth;

    // Determine which date is earlier
    if (this.date.getTime() < date.date.getTime()) {
      startYear = this.date.getFullYear();
      startMonth = this.date.getMonth();
      endYear = date.date.getFullYear();
      endMonth = date.date.getMonth();
    } else {
      startYear = date.date.getFullYear();
      startMonth = date.date.getMonth();
      endYear = this.date.getFullYear();
      endMonth = this.date.getMonth();
    }

    // Calculate the month difference
    const monthDifference = (endYear - startYear) * 12 + (endMonth - startMonth);

    // Return the absolute value to ensure the result is always positive
    return Math.abs(monthDifference);
  }

  static getCurrentGlossDate(): GlossDateOld {
    const date = new Date();
    const nowGlossDate = new GlossDateOld();

    nowGlossDate.date = date;
    nowGlossDate.dateString = date.toISOString().split("T")[0];
    nowGlossDate.time = date.toTimeString().split(" ")[0];
    nowGlossDate.timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;

    return nowGlossDate;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  getDateTimeAndZoneString(): string {
    return `${this.dateString.split("T")[0]}${this.time ? ", " + this.time : ""}${
      this.timeZone ? ", " + this.timeZone : ""
    }`;
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  static getTableDate(glossDate: GlossDateOld): string {
    const date = new Date(glossDate.date);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return year + "-" + month + "-" + day;
  }

  get WeekNumber() {
    // Following the ISO week date system, the week that contains the first Thursday (of the year) is the first week, a week starts on Monday, and that there are maximal 53 weeks in a year.
    // Reference: https://en.wikipedia.org/wiki/ISO_week_date
    const date = this.date;
    const startOfYear = new Date(date.getFullYear(), 0, 1); // 1 January
    const daysDifference = Math.floor(
      (date.getTime() - startOfYear.getTime()) / 86400000, // 1000 * 60 * 60 * 24
    );

    const startOfWeek = new Date(startOfYear);
    const firstThursday = new Date(startOfYear);
    firstThursday.setDate(startOfYear.getDate() + ((4 - startOfYear.getDay() + 7) % 7)); // get the date of the first Thursday (in a year)
    // 4 - startOfYear.getDay() = the difference between Thursday and the current day of the week
    // + 7 makes sure the result is not negative
    // & 7 ensures that the result is within the setDate's range of 0-6 (where Sunday represents 0)

    const weekNumber = Math.ceil((daysDifference + (startOfWeek.getDay() + 1)) / 7) + 1;

    if (date < firstThursday) {
      return 1;
    } else if (weekNumber > 53) {
      return 52;
    } else {
      return weekNumber;
    }
  }

  /**
   * @deprecated This function is deprecated and will be removed in the future.
   */
  getQuarter() {
    const date = this.date;
    return Math.floor(date.getMonth() / 3) + 1;
  }
}
